import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { Flex, Box, Copy } from '@elparking/components'

import { formatMinuteDuration } from 'commons/js/util/dateConverter'

import RestrictionBadge from './RestrictionBadge'
import messages from './messages'

const Restriction = ({ message }) => (
    <RestrictionBadge>
        <Copy as='span' padding='0' color='red' size='xxxSmall' fontWeight='regular'>
            <FormattedMessage {...message} />
        </Copy>
    </RestrictionBadge>
)

Restriction.propTypes = {
    message: PropTypes.shape({
        id: PropTypes.string,
        defaultMessage: PropTypes.string,
        values: PropTypes.object,
    }),
}

function ParkingRestrictions ({ restrictions }) {
    const { advanceMinutes, minStayMinutes, maxStayMinutes } = restrictions

    return (
        <Flex flexWrap='wrap'>
            {advanceMinutes && <Box mr='0.5em' mb='0.5em'>
                <Restriction message={{
                    ...messages.advanceRestriction,
                    values: { duration: formatMinuteDuration(advanceMinutes) } }}
                />
            </Box>}
            {minStayMinutes && <Box mr='0.5em' mb='0.5em'>
                <Restriction message={{
                    ...messages.minStayRestriction,
                    values: { duration: formatMinuteDuration(minStayMinutes) } }}
                />
            </Box>}
            {maxStayMinutes && <Box mb='0.5em'>
                <Restriction message={{
                    ...messages.maxStayRestriction,
                    values: { duration: formatMinuteDuration(maxStayMinutes) } }}
                />
            </Box>}
        </Flex>
    )
}

ParkingRestrictions.propTypes = {
    restrictions: PropTypes.shape({
        advanceMinutes: PropTypes.number,
        minStayMinutes: PropTypes.number,
        maxStayMinutes: PropTypes.number,
    }).isRequired,
}

ParkingRestrictions.defaultProps = {
    restrictions: {},
}

export default ParkingRestrictions
